import { render, staticRenderFns } from "./FormulaPerformance.vue?vue&type=template&id=1bced3ae&scoped=true"
import script from "./FormulaPerformance.vue?vue&type=script&lang=js"
export * from "./FormulaPerformance.vue?vue&type=script&lang=js"
import style0 from "./FormulaPerformance.vue?vue&type=style&index=0&id=1bced3ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bced3ae",
  null
  
)

export default component.exports